import systemRoutes from "../system/routes";
import dealRoutes from "./modules/deals";
import hotelRoutes from "./modules/hotels";
import cityCountryRoutes from "./modules/cities&countries";
import cruiseLineRoutes from "./modules/cruiselines&ships";
import pageRoutes from "./modules/pages";
import enquiryRoutes from "./modules/enquiries";
import referrerRoutes from "./modules/referrers";
import bookingRoutes from "./modules/bookings";
import blogRoutes from "./modules/blog";
import dealTypeRoutes from "./modules/dealTypes";
import seoRoutes from "./modules/seo";
import errorRoutes from "./modules/errors";
import paymentRoutes from "./modules/payments";
import dashboard from "../containers/dashboard";
import activityCategories from "./modules/activityCategories";
// import destinationCategories from "./modules/destinationCategories";
// import subCategories from "./modules/subCategories";
import searchTagsRoutes from "./modules/searchTags";
import DestinationCategoryRoutes from "./modules/destinationCategories";
import SubCategoryRoutes from "./modules/subCategories";
import bannerRoutes from "./modules/banners";
import cruiselineRoutes from "./modules/cruiselinePage";

const routes = [
  ...systemRoutes,
  ...seoRoutes,
  ...dealRoutes,
  ...hotelRoutes,
  ...cityCountryRoutes,
  ...cruiseLineRoutes,
  ...pageRoutes,
  ...enquiryRoutes,
  ...referrerRoutes,
  ...bookingRoutes,
  ...blogRoutes,
  ...dealTypeRoutes,
  ...paymentRoutes,
  ...activityCategories,
  ...DestinationCategoryRoutes,
  ...SubCategoryRoutes,
  ...searchTagsRoutes,
  ...bannerRoutes,
  ...cruiselineRoutes,

  {
    path: "/dashboard",
    exact: true,
    auth: true,
    component: dashboard,
  },
  ...errorRoutes,
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.jsx